import React from 'react';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';

import MobileMenu from './MobileMenu';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row-reverse !important',
    },
  },
  sponsorButtonWrapper: {
    display: 'flex',
    marginLeft: '10%',
  },
  sponsorButton: {
    fontSize: 18,
    lineHeight: '23px',
    borderRadius: '4px',
    textAlign: 'center',
    textTransform: 'none',
    letterSpacing: '-0.04rem',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      width: '200px',
    },
  },
  menuWrapper: {
    fontSize: 24,
    lineHeight: '31px',
    letterSpacing: '-0.04rem',
    display: 'flex',
    '& > a': {
      color: theme.palette.secondary.light,
      fontSize: 18,
      fontWeight: 'bold',
      margin: '0px 15px',
      height: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 20,
    },
  },
  mlhLogo: {
    marginTop: '-10px !important',
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
    },
    [theme.breakpoints.up('md')]: {
      alignItems: 'center',
    },
  },
  loginBtn: {
    fontSize: 18,
    lineHeight: '23px',
    borderRadius: '4px',
    textAlign: 'center',
    textTransform: 'none',
    letterSpacing: '-0.04rem',
  },
}));

const SponsorText = styled.b`
  display: flex;
  flex-direction: row;
  align-content: center;
  color: black;
`;

const MLHLogo = styled.img`
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  width: 80px;
  height: 150px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const MenuWrapper = styled.div`
  display: flex;
  & > * {
    margin: 0px 15px;
  }
`;

const Header = () => {
  const classes = useStyles();

  return (
    <Wrapper className={classes.root}>
      <MobileMenu />

      <div className={classes.sponsorButtonWrapper}>
        <Link href="mailto:hello@hackwestern.com">
          <SponsorText>
            <Button
              variant="contained"
              color="primary"
              className={classes.sponsorButton}>
              Become a Sponsor
            </Button>
          </SponsorText>
        </Link>
      </div>

      <MenuWrapper>
        <div className={classes.menuWrapper}>
          <Link href="#sponsors">Sponsors</Link>
          <Link href="#faq">FAQ</Link>
          <Link href="#contact">Contact</Link>
        </div>
        <Link
          href="https://mlh.io/"
          target="_Blank"
          className={classes.mlhLogo}>
          <MLHLogo src={require('./assets/mlh-logo.png')} alt="MLHLogo" />
        </Link>
      </MenuWrapper>
    </Wrapper>
  );
};

export default Header;
